<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="往来单位">
         <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <el-form-item label="单位类型">
          <el-select size="mini" v-model="params.TradeUnitType" placeholder="请选择单位类型" clearable>
            <el-option label="供应商" :value="3"></el-option>
            <el-option label="批发" :value="2"></el-option>
            <el-option label="零售" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TradeUnitName" label="往来单位" />
        <el-table-column prop="Amount" :label="IsPayment?'应收金额':'应付金额'" />
        <el-table-column prop="OtherAmount" :label="IsPayment?'其他应收金额':'其他应付金额'" />
        <el-table-column prop="PreAmount" :label="IsPayment?'预收金额':'预付金额'" />
        <el-table-column prop="BeginningDate" label="期初日期">
          <template slot-scope="{row}">{{row.BeginningDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="ExpireDate" label="收款到期日">
          <template slot-scope="{row}">{{row.ExpireDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitType" label="单位类型">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.TradeUnitType==3" type="primary">供应商</el-tag>
            <el-tag size="mini" v-else-if="row.TradeUnitType==1" type="danger">零售</el-tag>
            <el-tag size="mini" v-else type="success">批发</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.Status==0" type="danger">未生效</el-tag>
            <el-tag size="mini" v-else-if="row.Status==1" type="success">已生效</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list, unitDialog,customer },
  props: {
    IsPayment: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/sy/trade").default,
      params: {
        WarehouseId: null,
        TradeUnitType: null,
        TradeUnitId: null,
        TradeUnitName: "",
      },
    };
  },
  methods: {
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.params.TradeUnitId = e.Id;
      this.params.TradeUnitName = e.Name;
    },
  },
};
</script>